export default "__VITE_ASSET__C5eMP9yk__"